// import React from 'react'
import { Portal } from 'react-portal'

export { Portal }

export default Portal
